var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83333 0H20.1667C20.6529 0 21.1192 0.193154 21.463 0.536971C21.8068 0.880787 22 1.3471 22 1.83333V20.1667C22 20.6529 21.8068 21.1192 21.463 21.463C21.1192 21.8068 20.6529 22 20.1667 22H1.83333C1.3471 22 0.880787 21.8068 0.536971 21.463C0.193154 21.1192 0 20.6529 0 20.1667V1.83333C0 1.3471 0.193154 0.880787 0.536971 0.536971C0.880787 0.193154 1.3471 0 1.83333 0ZM8.06295 13.5875L7.17947 16.2935L8.76347 16.6015V17.4155H4.60547V16.6015L5.57347 16.3595C5.8228 16.3008 5.98414 16.1615 6.05747 15.9415L9.86347 4.85352H11.5795L15.5615 15.9415C15.6348 16.1615 15.7961 16.3008 16.0455 16.3595L16.9695 16.6015V17.4155H12.2175V16.6015L13.8235 16.2935L12.8789 13.5875H8.06295ZM8.37899 12.6195H12.541L10.3904 6.45878L8.37899 12.6195Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.e9e9103f9233f2942e51de054c4fa77a.svg";
export { ForwardRef as ReactComponent };